<template lang="pug">
a.btn.btn-default(
  @click="goToEdit()"
  @mousedown="hideTooltip"
  ref="editButton"
  data-toggle="tooltip"
  data-container="body"
  title="Edit"
)
  i.fa.fa-pencil
  span.edit-label(v-if="!hideLabel")
    |
    | Edit
</template>

<script>
  import { storyRoute } from '@/utils/route_helpers.js'

  export default {
    props: {
      storyId: {
        type: Number,
        required: true
      },

      hideLabel: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      hideTooltip() {
        if (this.$refs.editButton) {
          jQuery(this.$refs.editButton).tooltip('hide')
        }
      },

      goToEdit() {
        this.$router.push(storyRoute({
          storyRoute: 'editStory',
          issueRoute: 'editIssueStory',
          pageRoute: 'editPageStory',
          storyId: this.storyId,
          router: this.$router
        }))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .edit-label {
    margin-left: 5px;
  }
</style>
